//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { ClearMediumSVG } from './svg'

interface ClearMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const ClearMediumIcon: React.FC<ClearMediumIconProps> = forwardRef<
  ClearMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={ClearMediumSVG} sx={sx} />
))
